import { render, staticRenderFns } from "./ProductVariantFormItems.vue?vue&type=template&id=5d36fb98&"
import script from "./ProductVariantFormItems.vue?vue&type=script&lang=js&"
export * from "./ProductVariantFormItems.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantFormItems.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports